import React from "react";
import { Link, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import homeSVG from "../assets/imgs/home.svg";
import notificationBing from "../assets/imgs/notification-bing.svg";
import microphoneSVG from "../assets/imgs/microphone.svg";
import note2 from "../assets/imgs/note-2.svg";
import profileCircle from "../assets/imgs/profile-circle.svg";
import broadcast from "../assets/imgs/Broadcast.svg";
import message from "../assets/imgs/message.svg";
import message3 from "../assets/imgs/messages-3.svg";
import moneySend from "../assets/imgs/money-send.svg";

import "../assets/css/style.css";
import { useDarkMode } from "../contexts/DarkModeContext";
import { useSidebar } from "../contexts/SidebarContext";

const Sidebar = () => {
  const location = useLocation();
  const { darkMode } = useDarkMode();
  const { isCollapsed } = useSidebar();

  const menuItems = [
    {
      to: "/dashboard",
      img: homeSVG,
      text: "Feeds",
      activePaths: ["/dashboard", "/post/:postId", "/tiktok-video/:postId"],
    },
    {
      to: "/activity",
      img: notificationBing,
      text: "Activity",
      activePaths: ["/activity", "/activity/logs"],
    },
    {
      to: "/beef",
      img: microphoneSVG,
      text: "Beef",
      activePaths: [
        "/beef",
        "/create-beef",
        "/addtopics",
        "/tagpeople",
        "/adddebater",
      ],
    },
    {
      to: "/petition",
      img: note2,
      text: "Petition",
      activePaths: ["/petition", "/create-petition", "/sign-petition"],
    },
    {
      to: "/profile",
      img: profileCircle,
      text: "Profile",
      activePaths: ["/profile", "/profile/edit", "/podcast-details"],
    },
    {
      to: "/townhall",
      img: broadcast,
      text: "Town Hall",
      activePaths: [
        "/townhall",
        "/live-podcast",
        "/add-guest",
        "/upload-podcast",
        "/add-category",
      ],
    },
    {
      to: "/messages",
      img: message,
      text: "Messages",
      activePaths: ["/messages", "/users"],
    },
    {
      to: "/groups",
      img: message3,
      text: "Groups",
      activePaths: ["/groups", "/group"],
    },
    {
      to: "/rewards",
      img: moneySend,
      text: "Rewards",
      activePaths: ["/rewards", "/withdraw"],
    },
  ];

  const restrictedRoutes = [
    "/group",
    "/chat",
    "/live",
    "/go-live",
    "/settings/qod-categories",
    "/settings/select-sub-qod",
    "/settings/interest-categories",
    "/settings/select-sub-interest",
    "/pending-podcast",
  ];
  const isRestrictedRoute = restrictedRoutes.includes(location.pathname);

  // Return null if the current route is restricted
  if (isRestrictedRoute) {
    return null;
  }

  return (
    <aside
      className={`sidebar ${darkMode ? "dark-mode" : ""} ${
        isCollapsed ? "collapsed" : ""
      }`}
      style={{
        height: "calc(100vh - 60px)",
        width: isCollapsed ? "80px" : "250px",
        marginTop: "85px",
        backgroundColor: darkMode ? "#333" : "#fff",
        transition: "all 0.3s ease-in-out",
        position: "fixed",
      }}
    >
      <ul className="sidebar-nav">
        {console.log("location ", location.pathname)}
        {menuItems.map((item, index) => (
          <li
            key={index}
            className={`sidebar-item ${
              item.activePaths.includes(location.pathname) ||
              (item.activePaths.includes("/dashboard") &&
                (location.pathname.toString().startsWith("/post/") ||
                  location.pathname.toString().startsWith("/tiktok-video/")))
                ? "active"
                : ""
            }`}
          >
            <Link to={item.to} className="sidebar-link">
              <img src={item.img} alt="" className="sidebar-icon" />
              {!isCollapsed && <span>{item.text}</span>}
            </Link>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default Sidebar;
